import { IconButton, } from '@mui/material';
import { useDispatch } from 'react-redux';
import { logout } from '../redux/authSlice';
import { useNavigate } from 'react-router-dom';
import LogoutIcon from '@mui/icons-material/Logout';

const LogoutSuperAdmin = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
  
    const handleLogout = () => {
      dispatch(logout());
      navigate('/login');
    };

    return (
        <IconButton onClick={handleLogout} color="primary">
            <LogoutIcon/>
        </IconButton>
    )
}

export default LogoutSuperAdmin